import styled, { createGlobalStyle } from 'styled-components';
import BaseInputContainer from '@deprecated-ui/common/InputForm';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';

export const InputFormWrapper = styled.div`
  position: relative;
  margin-top: 15px;

  input:disabled {
    background-color: ${color.light} !important;
    color: #858585;
  }

  input:disabled + div {
    height: 0;
  }
`;

interface IInputContainer {
  error: boolean;
}

export const InputContainer = styled(BaseInputContainer).attrs({
  p: '0',
})<IInputContainer>`
  label {
    font-size: 14px;
  }

  input {
    &::placeholder {
      font-family: 'ProximaNovaLt';
    }
    font-size: 18px;
    color: ${color.highempahis};
    width: 100% !important;
    font-family: 'ProximaNovaLt';
    padding: 0;
  }

  input ~ label {
    font-size: 14px;
  }

  input:not(:placeholder-shown) ~ label {
    color: ${color.highempahis};
  }

  input:focus ~ label {
    color: ${color.black};
  }

  input:not(:placeholder-shown) ~ label,
  input:focus ~ label {
    font-family: 'ProximaNovaBd';
    font-size: 12px !important;
    top: -24px !important;
  }
`;

export const ErrorText = styled(Text).attrs({
  color: color.sunsetOrange,
})`
  font-family: 'ProximaNovaLt';
  font-weight: 300;
  font-size: 12px;
`;

export const ForgotPasswordStyle = createGlobalStyle`
  .forgot-password {
    border: none;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: 3px !important;

    button.ant-btn {
      border-radius: 3px;
      padding: 5px 16px;
    }


    button.ant-btn-default {
      border: 1px solid ${color.downgray};
    }

    button.ant-btn .ant-btn-loading-icon {
      display: flex;
    }

    button:disabled, button:disabled:hover {
      background-color: #8CD9BC !important;
      border-color: #8CD9BC !important;

      p {
        color: ${color.light} !important;
      }
    }

    @media ${device.mobileS} {
      padding: 28px 40px !important;
      width: 100% !important;
    }

    @media ${device.mobileL} {
      padding: 40px 50px !important;
      width: 450px !important;
    }
  }

  .auth-text-container {
    padding: 0;
  }

  .ant-message-notice.sysmsg-content {
    max-width: 440px !important;
  }
`;
